import { IonContent, IonHeader, IonPage, IonItem, IonIcon, IonButton, IonAlert, IonImg, IonRow, IonGrid, IonCol, IonAccordionGroup, IonAccordion, IonPopover } from '@ionic/react';
import { useParams } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import InnerMenu from '../components/InnerMenu';
import Map, {Marker, Popup, GeolocateControl, Source, Layer} from 'react-map-gl';
import GpsSinglePointComponent from '../components/GpsSinglePointComponent';
import {localStore} from '../App';
import PageEventHandler from "../components/PageEventHandler"
import 'mapbox-gl/dist/mapbox-gl.css';
import './IslandsMap.css';
import { BASE_URL } from '../utils/constant';
import IslandsService from '../services/IslandsService';
import MuseumsService from '../services/MuseumsService';
import { informationCircleOutline } from 'ionicons/icons';
import { LanguageContext } from '../contexts/LanguageContext';
import { islandsMapTranslations } from '../translations/islandsMap';
import NotificationRedirect from '../components/NotificationRedirect';

const islandsService = new IslandsService();
const museumsService = new MuseumsService();

const IslandsMap: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = islandsMapTranslations[language];

  const MAPBOX_TOKEN = 'pk.eyJ1IjoiYWxlLWFydCIsImEiOiJjbDFxbWxqa2wwZTNlM2xvM3M4bTEzZGpiIn0.HoRycofAyQPZ33Niv-XRtA'; // Set your mapbox token here
  const pageName = "Riserve della Biosferara";

  const [showAlert2, setShowAlert2] = useState(false);
  const [showAlert3, setShowAlert3] = useState(false);
  const [islandsList, setIslandsList] = useState<[any] | null>(null);
  const [loadingText, setLoadingText] = useState(t.loading);
  const [selectedIndex, setSelectedIndex] = useState<number|null>(null);
  const [museumsList, setMuseumsList] = useState<[any] | null>(null);
  const [source, setSource] = useState('');
  const [currentMabArea, setCurrentMabArea] = useState<string|null>(null);
  const [currentMabLogo, setCurrentMabLogo] = useState('');
  const [currentMabMessage, setCurrentMabMessage] = useState('');

  const [bearing, setBearing] = useState(0); // Store the map bearing (rotation)
  const [is3D, setIs3D] = useState(false); // Track if 3D view is enabled

  // this will be set in GpsSinglePointComponent
  const [userCoords, setUserCoords] = useState<any|null>(null)
  const [styleLoaded, setStyleLoaded] = useState(false)

  const [showInfoMuseums, setShowInfoMuseums] = useState(false);


  const islandPdfUrl = "https://www.portolanodelpo.it/wp-content/uploads/2022/05/RN2000_AstaPo.pdf";


    // fetch the list of islands from server or return an empty array
    async function fetchIslands()
    {
      if (islandsList == null)
      {
        try
        {
          // firstly try to get data from server
          const islands = await islandsService.fetchIslands();
          if (islands)
          {
            setIslandsList(islands);
          }
          else
          {
            setLoadingText(t.noIslandsMemory);
            setShowAlert2(true)
          }
        }
        catch (error)
        {
          console.log('Problema nella ricezione dei dati sulle isole ecologiche: ',error);
          setLoadingText(t.islandsError);
          setShowAlert2(true)
        }
      }
    }

    async function fetchMuseums()
    {
      if (museumsList == null)
      {
        try
        {
          const museums = await museumsService.fetchMuseums();
          if (museums)
          {
            setMuseumsList(museums);
          }
          else
          {
            setLoadingText(t.noIslandsMemory);
            setShowAlert2(true)
          }
        }
        catch (error)
        {
          console.log('Problema nella ricezione dei dati sulle musei: ',error);
          setLoadingText(t.islandsError);
          setShowAlert2(true)
        }
      }
    }

    function determineMabArea(longitude: number)
    {
      let newArea = null;

      if (longitude < 9.153148063521808) 
      {
        newArea = 'Ticino Val Grande Verbano';
        setCurrentMabLogo(`${process.env.PUBLIC_URL}/assets/images/logo-MAB-Ticino.png`);
      }
      else if (longitude < 11.978976525958304) 
      {
        newArea = 'Po Grande';
        setCurrentMabLogo(`${process.env.PUBLIC_URL}/assets/images/logo-MAB-po-grande.png`);
      }
      else 
      {
        newArea = 'Delta Po';
        setCurrentMabLogo(`${process.env.PUBLIC_URL}/assets/images/logo-MAB-delta-po.png`);
      }
      
      if (currentMabArea && newArea !== currentMabArea) // Show goodbye/welcome alerts
      {
        setShowAlert3(true);
        setCurrentMabMessage(`${t.goodbyeMAB} ${currentMabArea}!\n${t.andWelcome} ${newArea}!`);
      }
      else if (!currentMabArea) // First time setting - just show welcome
      {
        setShowAlert3(true);
        setCurrentMabMessage(`${t.welcomeMAB} ${newArea}!`);
      }
      
      setCurrentMabArea(newArea);
    };

     function closePopup()
     {
         setSelectedIndex(null)
     }

     function openPopup(index:number, source: string)
     {
        setSelectedIndex(null)
        setSource(source);
        setSelectedIndex(index)
     }

   // js code to programmatically trigger the geolocation service on map load
   // this is being called on Map.onStyleData as Map.onload doesn't get called
   function activateGeolocator()
   {
     if (!styleLoaded)
     {
       (document.getElementsByClassName("mapboxgl-ctrl-geolocate")[0] as HTMLElement).click();
       setStyleLoaded(true);
     }
   }

     useEffect(() => {
       // get islands from memory or server
       fetchIslands();
       // get museums from memory or server
       fetchMuseums();

       // everytime userCoords updates, determine the MAB area
       if (userCoords)
       {
         determineMabArea(userCoords.longitude);
       }


      // Function to update bearing when the user's location changes
      const handleLocationUpdate = (position: any) => {
        const heading = position.coords.heading;
        if (heading !== null) 
        {
          setBearing(heading); // Update the bearing
        }
      };

     }, [userCoords]); // empty dependency array to call userEffect() only once, onload.

    // Update loading text when language changes
    useEffect(() => {
      setLoadingText(t.loading);
    }, [language]);

     return (
       <IonPage>
         <IonHeader>
           <InnerMenu name={t.pageTitle} />
         </IonHeader>
         <IonContent fullscreen>
           <IonButton routerLink="/islands" expand="block" fill="solid" className="ion-padding reg-islBtn" >
             {t.backToList}
           </IonButton>
           <IonButton target="_blank" rel="noreferrer" routerLink={islandPdfUrl} expand="block" fill="solid" className="ion-padding signBtn ion-text-wrap">
             {t.legend}
           </IonButton>
          
           {/* {userCoords != null &&
              <p>
              {/*************************** DEV CODE - TO BE REMOVED!! ************************** /}
                &nbsp;user longitude: {userCoords.longitude}
              </p>
            } */}

        <IonAccordionGroup>
          <IonAccordion value="legend">
            <IonItem slot="header">
              <h2>{t.legendTitle}</h2>
            </IonItem>
            <IonGrid slot="content">
              {/* <IonRow>
                <IonCol key={1} size="2">
                  <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/line.svg`} className="dock-legend-icon"></IonIcon>
                </IonCol>
                <IonCol key={2} size="10">
                  Idrovia navigabile
                </IonCol>
              </IonRow> */}
              <IonRow>
                <IonCol key={1} size="1" style={{textAlign: 'center'}}>
                  <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/map-marker.svg`} className="dock-legend-icon"></IonIcon>
                </IonCol>
                <IonCol key={2} size="5">
                  {t.poMuseums}
                  </IonCol>
                <IonCol key={3} size="1">
                  <IonButton  className="info-museum-btn" fill="clear" id="museum-trigger">
                    <IonIcon icon={informationCircleOutline}></IonIcon>
                  </IonButton>
                  <IonPopover trigger="museum-trigger" triggerAction="click" className="museum-popover" >
                    <IonContent class="ion-padding">{t.museumInfo}</IonContent>
                  </IonPopover>
                </IonCol>
              </IonRow>
              <IonRow>
              <IonCol key={4} size="1" style={{textAlign: 'center'}}>
              <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/map-marker-green.svg`} className="dock-legend-icon"></IonIcon>
              </IonCol>
                <IonCol key={5} size="5">
                  {t.naturalAreas}
                </IonCol>
                <IonCol key={6} size="1">
                  <IonButton  className="info-museum-btn" fill="clear" id="islands-trigger">
                    <IonIcon icon={informationCircleOutline}></IonIcon>
                  </IonButton>
                  <IonPopover trigger="islands-trigger" triggerAction="click" className="museum-popover" >
                    <IonContent class="ion-padding">{t.naturalAreasInfo}</IonContent>
                  </IonPopover>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonAccordion>
        </IonAccordionGroup>


           {/* if loading went fine */}
           {islandsList != null && islandsList.length > 0 && museumsList != null && museumsList.length > 0 &&
             <>
             <Map
               id="islandMap"
               initialViewState={{
                 latitude: 45.1805924522949,
                 longitude: 9.15369798292832,
                 zoom: 11,
                 bearing: bearing, // Set the bearing based on user movement
                 pitch: is3D ? 60 : 0, // Adjust pitch for 3D effect
               }}
               mapStyle="mapbox://styles/ale-art/cl3g0eg0b000r14qp6hseetrq"
               mapboxAccessToken={MAPBOX_TOKEN}
               onStyleData={activateGeolocator}
             >

            {/* if we got user location and a logo, show the correct logo of the MAB area*/}
            {currentMabLogo != '' &&
              <div>
                  <IonImg class="ion-margin" slot="start" alt="Logo MAB" src={currentMabLogo} id="logoMAB" />
              </div>
            }

               {/* add island markers */}
               {islandsList.map((dock, index) => (
                     <Marker key={index} longitude={dock.lng} latitude={dock.lat} color="green" onClick={() => openPopup(index, 'island')} />
                 ))
               }
               {/* add island popup */}
               {selectedIndex !== null && source == 'island' && islandsList != null &&
                   <Popup
                     latitude={islandsList[selectedIndex].lat}
                     longitude={islandsList[selectedIndex].lng}
                     onClose={closePopup}
                     closeButton={true}
                     closeOnClick={false}
                     offset={35}
                     className="mapPopup"
                    >
                     <p>{islandsList[selectedIndex].name}</p>
                   </Popup>
                }

               {/* add museums markers */}
               {museumsList.map((museum, index) => (
                     <Marker key={'m'+index} longitude={museum.coordinate_longitudine} latitude={museum.coordinate_latitudine} color="brown" onClick={() => openPopup(index, 'museum')} />
                 ))
                }

               {/* add museum popup */}
               {selectedIndex !== null && source == 'museum' && museumsList != null &&
                <Popup
                  latitude={museumsList[selectedIndex].coordinate_latitudine}
                  longitude={museumsList[selectedIndex].coordinate_longitudine}
                  onClose={closePopup}
                  closeButton={true}
                  closeOnClick={false}
                  offset={35}
                  className="mapPopup"
                 >
                  <p>{museumsList[selectedIndex].museo}</p>
                  <p>
                    <a href={'https://'+museumsList[selectedIndex].sito} target="_blank" rel="noreferrer">
                      {t.visitMuseum}
                    </a>
                  </p>
                </Popup>
              }

              <Source
                id="openseamap"
                type="raster"
                tiles={['https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png']}
                tileSize={256}
              />
              <Layer
                id="openseamap-layer"
                type="raster"
                source="openseamap"
              />

              {/* add geolocation control */}
              <GeolocateControl showUserLocation={true} trackUserLocation={true} showAccuracyCircle={true} showUserHeading={true} />
            </Map>
            </>
          }
         </IonContent>
         <IonAlert
           header={t.errorHeader}
           isOpen={showAlert2} message={t.errorMessage} buttons={[{ text: t.okButton }]} onDidDismiss={() => setShowAlert2(false)} />

         <IonAlert
           header={currentMabMessage}
           isOpen={showAlert3} message="" buttons={[{ text: t.okButton }]} onDidDismiss={() => setShowAlert3(false)} />

          <IonAlert 
          isOpen={showInfoMuseums} 
          message={"In questa sezione si può trovare una prima rete di conoscenza museale sul Po, in cui esaltare e valorizzare le varie forme con le quali il fiume è associato alla presenza dell'uomo, per tradizione, storia, memoria, componente naturalistica, arte."} 
          buttons={[{ text: 'Ok' }]} 
          onDidDismiss={() => setShowInfoMuseums(false)} 
          />
         <GpsSinglePointComponent setUserCoords={setUserCoords}/> {/* pass the setter function to the child so we maintain the state watcher */}
         <PageEventHandler pageIndex={6} dockIndex={0}/>
         <NotificationRedirect /> {/* redirect to the page specified in the local storage */}
       </IonPage>
     );
   };

export default IslandsMap;
